var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.5C14.4183 13.5 18 12.1569 18 10.5V16.5C18 18.1569 14.4183 19.5 10 19.5C5.58172 19.5 2 18.1569 2 16.5V10.5C2 12.1569 5.58172 13.5 10 13.5Z",
    fill: "#647FB4",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.748 9.75C16.8599 11.0439 13.7277 12 10 12C6.27232 12 3.14012 11.0439 2.25203 9.75C2.08751 9.98971 2 10.241 2 10.5C2 12.1569 5.58172 13.5 10 13.5C14.4183 13.5 18 12.1569 18 10.5C18 10.241 17.9125 9.98972 17.748 9.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 4,
    rx: 8,
    ry: 3,
    fill: "#647FB4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7C14.4183 7 18 5.65685 18 4V9C18 10.6569 14.4183 12 10 12C5.58172 12 2 10.6569 2 9V4C2 5.65685 5.58172 7 10 7Z",
    fill: "#647FB4",
    fillOpacity: 0.55
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDatabase);
export default __webpack_public_path__ + "static/media/icon-database.b39fb1b11d89962381154b75ff476d20.svg";
export { ForwardRef as ReactComponent };